var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "92", height: "44", viewBox: "0 0 92 44" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "id-46a", d: "M37 32H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h78a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H49l-5.293 5.293a1 1 0 0 1-1.414 0L37 32z" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", transform: "translate(3 3)" },
      React.createElement("use", { fill: "#029499", xlinkHref: "#id-46a" }),
      React.createElement("path", { stroke: "#B2DADB", strokeWidth: "3", d: "M36.379 33.5H4A5.5 5.5 0 0 1-1.5 28V4A5.5 5.5 0 0 1 4-1.5h78A5.5 5.5 0 0 1 87.5 4v24a5.5 5.5 0 0 1-5.5 5.5H49.621l-4.853 4.854a2.5 2.5 0 0 1-3.536 0L36.38 33.5z" }),
      React.createElement("path", { stroke: "#017175", strokeLinejoin: "square", d: "M4 31.5h33.207l5.44 5.44a.5.5 0 0 0 .707 0l5.439-5.44H82a3.5 3.5 0 0 0 3.5-3.5V4A3.5 3.5 0 0 0 82 .5H4A3.5 3.5 0 0 0 .5 4v24A3.5 3.5 0 0 0 4 31.5z" })
    )
  );
});